@import 'vars';

.highlight-text {
  &__part {
    color: $primary;
  }
}
